import {Action, getModule, Module, MutationAction, Mutation, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {IPaymentArticles, IPaymentArticlesListItem, PaymentArticlesResponseType} from "@/entity/finance/payment_articles/paymentArticles.types";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {PaymentArticlesGeneralRequestType} from "@/form/finance/payment_articles/PaymentArticlesGeneral.types";
import {ResponseDataType} from "@/form/form.types";
import {createLogger} from "vuex";
import { prepareFormData } from '@/store/utils/formDataHelper';
@Module({
    namespaced: true,
    name: 'paymentArticles',
    store,
    dynamic: true,
})
class PaymentArticlesModule extends VuexModule {
    paymentArticles: IPaymentArticles | null = null;
    item: IPaymentArticlesListItem | null = null;
    itemsLoaded = false;
    @Mutation
    setPaymentArticles(paymentArticles: IPaymentArticles): void {
        this.paymentArticles = paymentArticles;
    }
    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ paymentArticles: IPaymentArticles; itemsLoaded: boolean }> {
        let itemsLoaded = false;
        const paymentArticles = await store.$repository.paymentArticles.fetchAll(prepareFormData(data));
        this.context.commit('setPaymentArticles', JSON.parse(JSON.stringify(paymentArticles)));

        if (paymentArticles) {
            itemsLoaded = true;
        }
        return { paymentArticles, itemsLoaded};
    }
    @MutationAction
    async fetchIncome(data?: PaginationRequestType): Promise<{ paymentArticles: IPaymentArticles; itemsLoaded: boolean }> {
        let itemsLoaded = false;
        const paymentArticles = await store.$repository.paymentArticles.fetchIncome(prepareFormData(data));

        if (paymentArticles) {
            itemsLoaded = true;
        }
        return { paymentArticles, itemsLoaded};
    }
    @Action({rawError: true})
    async create(data: PaymentArticlesGeneralRequestType): Promise<ResponseDataType> {
        return await store.$repository.paymentArticles.create(data);
    }
    @Action({rawError: true})
    async update(data: PaymentArticlesGeneralRequestType): Promise<ResponseDataType> {
        return await store.$repository.paymentArticles.update(data);
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        const resp = await store.$repository.paymentArticles.delete(data);
        return resp;
    }

    /*@MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ salon: IPaymentArticlesListItem  ; itemsLoaded: boolean }> {
        let itemsLoaded = false;
        const salon = await store.$repository.paymentArticles.fetchData(data);
        if (salon) {
            itemsLoaded = true;
        }
        return { salon, itemsLoaded};
    }
    @Action({rawError: true})
    async create(data: PaymentArticlesGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.paymentArticles.create(data);
        return resp;
    }
    @Action({rawError: true})
    async update(data: PaymentArticlesGeneralRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.paymentArticles.update(data);
        return resp;
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        const resp = await store.$repository.paymentArticles.delete(data);
        return resp;
    }*/
}

export const PaymentArticlesStore = getModule(PaymentArticlesModule);
